export const primaryColor = "#FDF8EE";
